import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3965db24&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=3965db24&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965db24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/Loading/index.vue').default,PhoneNumberInput: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/PhoneNumberInput/index.vue').default})
